import { render, staticRenderFns } from "./phone-section.vue?vue&type=template&id=e812fc60"
import script from "./phone-section.vue?vue&type=script&lang=js"
export * from "./phone-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports